import { getMedalHiscores as getMedalHiscoresFromDb } from "@dailywars/core/db";
import { createServerFn } from "@tanstack/react-start";

import { setRouteAction } from "#/lib/requestLogger.server";
import { getMedalHiscoresInputSchema } from "#/lib/serverInputSchemas";

const HISCORES_PAGE_SIZE = 100;

export const getMedalHiscores = createServerFn({ method: "GET" })
  .validator(getMedalHiscoresInputSchema)
  .handler(async ({ data }) => {
    setRouteAction("medal_hiscores");
    return getMedalHiscoresFromDb({
      period: data.period,
      limit: HISCORES_PAGE_SIZE,
      cursor: data.cursor,
    });
  });
